// Рублёвые тарифы для веба и Android — те же числа, что в api/payment.js
// (SUBSCRIPTION_PLANS) и в письме о лимите (lib/limitEmail.js): менять вместе.
// В iOS цены на экранах берутся из App Store (services/iap.js, applePrices):
// Apple сверяет цифры на экране с ценой подписки.
export const RF_PRICES = {
  monthly: '390 ₽',
  annualTotal: '2 400 ₽',
  annualPerMonth: '200 ₽',
  savingPerMonth: '190 ₽',
  badgePercent: 49,
  annualAutoRenew: false,
}

// Пока StoreKit не вернул продукты: многоточия вместо цифр, год с
// автопродлением (у Apple обе подписки auto-renewable)
export const PENDING_PRICES = {
  monthly: null,
  annualTotal: null,
  annualPerMonth: null,
  savingPerMonth: null,
  badgePercent: null,
  annualAutoRenew: true,
}
